const STORAGE_KEY = 'sms-campaigns-onboarding-acknowledged';

export const isOnboardingAcknowledged = (): boolean => {
  return localStorage.getItem(STORAGE_KEY) === 'true';
};

export const acknowledgeOnboarding = (): void => {
  localStorage.setItem(STORAGE_KEY, 'true');
};
